export default "__VITE_ASSET__BcmGp0Nw__"